import { useAwardDelete } from '@/module/Author/Award';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface AwardDeleteButtonProps {
  awardId: Id;
}

export function AwardDeleteButton({ awardId }: AwardDeleteButtonProps) {
  const mutation = useAwardDelete(awardId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
